import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { getData } from "../../../../../../services/library";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { UrlApi } from "../../../../../../services/apirest";
import moment from "moment";

function AddPrecioEspecial(props) {
  const [productos, setProductos] = useState([]);
  const [todosProductos, setTodosProductos] = useState(false);
  const [productosSeleccionados, setProductosSeleccionados] = useState([])
  const [productoInput, setProductoInput] = useState("");
  const [filtroProductos, setFiltroProductos] = useState("");
  const [precioMinimo, setPrecioMinimo] = useState("");
  // const [precioMaximo, setPrecioMaximo] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    getData("/productos/envasados", (data) => setProductos(data));
  }, []);

const handleToggleTodosProductos = (event) => {
  const checked = event.target.checked;
  setTodosProductos(checked);

  if (checked) {
    // Solo selecciono los que NO están en precioEspecial
    const filtrados = productos.filter(
      (p) => !productosConPrecioEspecial.includes(p.idproducto)
    );
    setProductosSeleccionados(filtrados);
  } else {
    setProductosSeleccionados([]);
  }
};
  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);

  const handlePrecioMinimo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMinimo(value);
    }
  };

  // const handlePrecioMaximo = (e) => {
  //   const value = e.target.value;
  //   if (validarInput(value)) {
  //     setPrecioMaximo(value);
  //   }
  // };

  const handleAgregarProducto = (producto) => {
    if (
      producto &&
      !productosSeleccionados.some((p) => p.idproducto === producto.idproducto)
    ) {
      setProductosSeleccionados((prev) => [...prev, producto]);
      setProductoInput("");
      // Si se agrega manualmente un producto, desmarcar "Todos"
      if (todosProductos) {
        setTodosProductos(false);
      }
    }
  };

  const eliminarProducto = (id) => {
    const nuevosProductos = productosSeleccionados.filter(
      (p) => p.idproducto !== id
    );
    setProductosSeleccionados(nuevosProductos);

    // Si no hay productos seleccionados, marcar "Todos" como false
    if (nuevosProductos.length === 0) {
      setTodosProductos(false);
    }

    // Si se eliminó alguno, ya no están todos seleccionados
    if (todosProductos) {
      setTodosProductos(false);
    }
  };

  // const productosDisponibles = productos.filter(
  //   (p) => !productosSeleccionados.some((pp) => pp.idproducto === p.idproducto)
  // );

  const productosFiltrados = productosSeleccionados.filter((p) =>
    p.nombre.toLowerCase().includes(filtroProductos.toLowerCase())
  );


  const handleClose = () => {
    props.setOpen(false);
    props.actualizar()
  };

  const handleGuardar = async () => {
  try {
    if (productosSeleccionados.length === 0) {
      alert("Debes seleccionar al menos un producto");
      return;
    }

    // armo todas las promesas
    const requests = productosSeleccionados.map((producto) =>
      fetch(UrlApi+"/envasado_precios_especiales", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          producto: producto.idproducto,
          cliente: props.cliente.id, // si tenés cliente
          precio_minimo: precioMinimo || null,
          // precio_maximo: precioMaximo || null,
        }),
      })
    );

    // espero que todas terminen
    const responses = await Promise.all(requests);

    // chequeo si todas fueron ok
    const allOk = responses.every((res) => res.ok);

    if (allOk) {
      // 3) Construyo historial (1 registro por producto seleccionado)
      const historial = productosSeleccionados.map((producto) => ({
        producto: producto.idproducto,
        cliente: props.cliente.id,
        precio_minimo_anterior: 0, // porque es la primera vez
        // precio_maximo_anterior: 0,
        precio_minimo_nuevo: precioMinimo || null,
        // precio_maximo_nuevo: precioMaximo || null,
        fecha: moment().format("YYYY-MM-DD"),
        usuario: localStorage.getItem("user"),
      }));

      // 4) Guardo historial en lote
      await guardarHistorial(historial);

      setSnackbar({
        open: true,
        message: "Precios guardados correctamente",
        severity: "success",
      });
      handleClose();
    } else {
      setSnackbar({
        open: true,
        message: "Ocurrió un error al guardar uno o más precios",
        severity: "error",
      });
    }
  } catch (error) {
    console.error("Error guardando precios:", error);
    setSnackbar({
      open: true,
      message: "Error al guardar precios especiales",
      severity: "error",
    });
  }
};

const guardarHistorial = async (historial) => {
  try {
    const resp = await fetch(`${UrlApi}/envasado_historial_especial/multiple`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(historial),
    });

    const data = await resp.json();
    if (!data.err) {
      console.log("Historial guardado correctamente");
    } else {
      console.error("Error guardando historial", data.err);
    }
  } catch (error) {
    console.error("Error en fetch historial:", error);
  }
};


  const isGuardarDisabled =
    productosSeleccionados.length === 0 ||
    (!precioMinimo );

    // 1) Armar una lista de IDs de productos que ya tienen precio especial
const productosConPrecioEspecial = props.precioEspecial?.map(
  (p) => parseInt(p.producto) // viene como string, lo paso a número
) || [];

// 2) Filtrar productos disponibles excluyendo los que ya tienen precio especial
const productosDisponibles = productos.filter(
  (p) =>
    !productosSeleccionados.some((pp) => pp.idproducto === p.idproducto) &&
    !productosConPrecioEspecial.includes(p.idproducto)
);

  return (
    <div>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="md"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Nuevo Precio Especial
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={todosProductos}
                    onChange={handleToggleTodosProductos}
                  />
                }
                label="Todos los Productos"
              />
            </Box>
            <Autocomplete
              size="small"
              disabled={todosProductos}
              options={productosDisponibles}
              getOptionLabel={(p) => p.nombre}
              value={null}
              inputValue={productoInput}
              onInputChange={(_, value) => setProductoInput(value)}
              onChange={(_, value) => handleAgregarProducto(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Agregar producto"
                  placeholder="Buscar..."
                />
              )}
            />

            <Box
              mt={1}
              sx={{
                border: "1px solid #ccc",
                borderRadius: "5px",
                padding: "10px",
                backgroundColor: "#f9f9f9",
                height: 150,
                overflowY: "auto",
              }}
            >
              <Box
                mb={0.5}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontWeight="bold" color="#1F618D">
                  Productos Seleccionados:
                </Typography>
                <TextField
                  size="small"
                  placeholder="Buscar..."
                  value={filtroProductos}
                  onChange={(e) => setFiltroProductos(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ width: "50%" }}
                />
              </Box>

              {productosFiltrados.length > 0 ? (
                productosFiltrados.map((p) => (
                  <Box
                    key={p.idproducto}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    // mb={0.5}
                    borderTop={1} // Borde de 1px
                    borderColor="divider" // Usa el color de tema 'divider'
                    pt={1} // Padding top
                    sx={{
                      "&:first-of-type": {
                        borderTop: "none", // Sin borde para el primer elemento
                      },
                    }}
                  >
                    <Typography variant="body2">• {p.nombre}</Typography>
                    <IconButton
                      size="small"
                      onClick={() => eliminarProducto(p.idproducto)}
                    >
                      <DeleteIcon fontSize="small" color="error" />
                    </IconButton>
                  </Box>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  {filtroProductos
                    ? "No hay coincidencias"
                    : "No hay productos seleccionados"}
                </Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={12}>
              <TextField
                    size="small"
                    type="text"
                    focused
                    color="primary"
                    placeholder="$"
                    name="precio_minimo"
                    label="Precio "
                    value={precioMinimo}
                    onChange={handlePrecioMinimo}
                    inputProps={{
                      maxLength: 10,
                    }}
                    fullWidth
                    onKeyPress={(event) => {
                      if (!/[0-9.]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
          </Grid>
          {/*<Grid item xs={6}>
            <TextField
            fullWidth
                    size="small"
                    type="text"
                    focused
                    color="primary"
                    placeholder="$"
                    name="precio_maximo"
                    label="Precio Máximo"
                    value={precioMaximo}
                    onChange={handlePrecioMaximo}
                    inputProps={{
                      maxLength: 10,
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9.]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
          </Grid>*/}
          </Grid>
          <Grid container direction="row" justifyContent="space-between" mt={1}>
            <Grid item>
              <Button
                color="error"
                variant="outlined"
                onClick={() => handleClose()}
                style={{ backgroundColor: "#fff" }}
              >
                Volver
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                color="success"
                variant="contained"
                // endIcon={<SaveIcon />}
                disabled={isGuardarDisabled}
                onClick={handleGuardar}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
          {/* </Box> */}
        </DialogContent>
      </Dialog>
       {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          sx={{ width: "100%" }}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default AddPrecioEspecial;
